//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import dialogMixin from '@/mixin/dialog';

export default {
  name: 'TeacherWelcomeDialog',
  mixins: [dialogMixin],
  data() {
    return {};
  },
  computed: {
    ...mapGetters('user', ['userName']),
  },
  methods: {
    gotoTeachers() {
      this.close();
    },
  },
};
